class SmartGeocodeModel extends App.Models.BaseModel {
    modelUrl = 'SmartGeocode';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.SmartGeocode = SmartGeocodeModel;
